var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-row", [
    _c(
      "div",
      { staticClass: "col-md-6" },
      [
        _c("card", { staticClass: "stacked-form" }, [
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.doSubmit($event)
                }
              }
            },
            [
              _c(
                "div",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c("label", { attrs: { for: "" } }, [_vm._v("Role")]),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            size: "large",
                            clearable: "",
                            placeholder: "Role"
                          },
                          model: {
                            value: _vm.model.role_id,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "role_id", $$v)
                            },
                            expression: "model.role_id"
                          }
                        },
                        _vm._l(_vm.roleList, function(role) {
                          return _c("el-option", {
                            key: role.id,
                            attrs: { value: role.value, label: role.label }
                          })
                        })
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Permission" } },
                        [
                          _c("b-form-checkbox-group", {
                            attrs: {
                              id: "checkbox-group-1",
                              options: _vm.permissionList,
                              name: "flavour-1"
                            },
                            model: {
                              value: _vm.model.permission,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "permission", $$v)
                              },
                              expression: "model.permission"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("save-data-button", {
                    attrs: {
                      disabled: _vm.saveButtonData.isLoading,
                      "is-create": _vm.$route.params.id === undefined,
                      state:
                        _vm.saveButtonData.isLoading &&
                        _vm.saveButtonData.state === 1
                          ? 2
                          : _vm.saveButtonData.state,
                      "is-loading": _vm.saveButtonData.isLoading
                    }
                  }),
                  _vm._v(" "),
                  _c("cancel-button")
                ],
                1
              )
            ]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5cc0f7c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cc0f7c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Pages/Settings/Permission/Form.vue
// module id = gA0L
// module chunks = 4